"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionRecalculationBannerWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var components_1 = require("@athena-portal/components");
var moment = require("moment");
var commonFunctions_1 = require("../../commonFunctions");
var SubscriptionRecalculationBannerWidget = exports.SubscriptionRecalculationBannerWidget = /** @class */ (function (_super) {
    __extends(SubscriptionRecalculationBannerWidget, _super);
    function SubscriptionRecalculationBannerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    SubscriptionRecalculationBannerWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getSubscription().subscribe(function (subscription) { return _this.setState({ subscription: subscription }); });
    };
    SubscriptionRecalculationBannerWidget.prototype.render = function () {
        if (this.state.subscription) {
            var additionalPremium = this.props.interaction.factors.additionalPremium;
            var premium = this.props.interaction.factors.premium;
            var isSubscriptionRecalculated = additionalPremium && additionalPremium != premium;
            if (isSubscriptionRecalculated) {
                return (React.createElement("div", { className: "panel base-widget banner banner-info" },
                    React.createElement("span", null,
                        "Heads up - because you already are a ",
                        React.createElement("b", null, "Flow customer"),
                        ", we recalculated your price based on your ",
                        React.createElement("b", null, "Flow subscription dates"),
                        ". "),
                    React.createElement("span", null,
                        "You only need to pay ",
                        React.createElement("b", { id: "recalculatedPrice" }, (0, commonFunctions_1.getAmountToDisplay)(additionalPremium ? additionalPremium : premium)),
                        " now, "),
                    React.createElement("span", null,
                        "which will cover you from ",
                        React.createElement("b", null, moment.utc(this.props.interaction.headerInfo.startDate).format("D MMMM YYYY")),
                        " until ",
                        React.createElement("b", null, moment.utc(this.props.interaction.headerInfo.endDate).format("D MMMM YYYY")),
                        ". "),
                    React.createElement("span", null,
                        "After that, your future ",
                        React.createElement("b", null, "Flow subscription payments"),
                        " will include your all active covers and will be taken on ",
                        React.createElement("b", null, moment.utc(this.props.interaction.headerInfo.endDate).add(1, 'days').format("D")),
                        " day of the month, unless you choose to change it.")));
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        }
        else {
            return React.createElement(components_1.Overlay, { show: true });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], SubscriptionRecalculationBannerWidget.prototype, "customerPortalService", void 0);
    return SubscriptionRecalculationBannerWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=SubscriptionRecalculationBannerWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/SubscriptionRecalculationBannerWidget.js
// module id = 3472
// module chunks = 0